import { Tooltip, IconButton, ButtonGroup } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getCookies } from "../../services/Cookies";


const defaultRender = (value) => (value ? value : '--');

const handleDownload = async (report, setReports) => {
    const clientId = getCookies('clientId');
    if (typeof setReports !== "function") {
        console.error("setReports is not a function:", setReports);
        return;
    }

    const storedReports = JSON.parse(localStorage.getItem(`savedReports_${clientId}`)) || [];
    const foundReport = storedReports.find((r) => r.name === report.name);

    if (!foundReport) {
        console.error("Report not found in localStorage.");
        return;
    }

    const { type, content, name } = foundReport;

    if (type === "pdf") {
        const doc = new jsPDF("p", "mm", "a4");

        const element = document.createElement("div");
        element.innerHTML = content;
        document.body.appendChild(element);

        html2canvas(element, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let y = 10;

            if (imgHeight > 290) {
                let pageHeight = 295;
                let heightLeft = imgHeight;
                let position = 0;

                doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft > 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
            } else {
                doc.addImage(imgData, "PNG", 0, y, imgWidth, imgHeight);
            }

            doc.save(name);
            document.body.removeChild(element);
        });
    } else {
        const blob = new Blob([content], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
    }

    // ✅ Update the status to "Downloaded"
    const updatedReports = storedReports.map((r) =>
        r.name === report.name ? { ...r, status: `${'downloaded'}` } : r
    );

    setReports(updatedReports);
    localStorage.setItem(`savedReports_${clientId}`, JSON.stringify(updatedReports));
};


const createReportCell = ({ handleOpen, handleDeleteOpen, setReports, t }) => {
    return [
        { title: t("name"), field: 'name', render: defaultRender },
        { title: t("date/time"), field: 'datetime', render: defaultRender },
        { title: t("status"), field: 'status', render: defaultRender },
        {
            title: <Tooltip title={t('createReport')}>
                <IconButton onClick={handleOpen}><AddCircleOutlineIcon sx={{ fontSize: "20px" }} /></IconButton>
            </Tooltip>,
            field:  t("actions"),
            render: (row) => (
                <>
                    <ButtonGroup variant="outlined" size="small">
                        <Tooltip title={t("download")}>
                            <IconButton onClick={() => handleDownload(row, setReports)}><DownloadOutlinedIcon sx={{ fontSize: "16px", color: "#1976D2" }} /></IconButton>
                        </Tooltip>

                        <Tooltip title={t('deleteBtn')}>
                            <IconButton onClick={() => handleDeleteOpen(row)}><DeleteOutlineIcon sx={{ fontSize: "16px", color: "#D32F2F" }} /></IconButton>
                        </Tooltip>
                    </ButtonGroup>
                </>
            )
        },
    ];
}

export default createReportCell;
